import { useSyncExternalStore } from "react";
import { formatIDR } from "./api";

const IDLE_MS = 60000;
const ACTIVITY = ["pointerdown", "keydown", "scroll", "touchstart", "mousemove"];
const listeners = new Set();
let visible = false;
let timer = null;

const emit = () => listeners.forEach((l) => l());
const bump = () => { clearTimeout(timer); timer = setTimeout(hide, IDLE_MS); };
const onVisibility = () => { if (document.hidden) hide(); };

function hide() {
  if (!visible) return;
  visible = false;
  clearTimeout(timer);
  ACTIVITY.forEach((e) => window.removeEventListener(e, bump, true));
  document.removeEventListener("visibilitychange", onVisibility);
  emit();
}

function show() {
  visible = true;
  ACTIVITY.forEach((e) => window.addEventListener(e, bump, { capture: true, passive: true }));
  document.addEventListener("visibilitychange", onVisibility);
  bump();
  emit();
}

export const toggleAmounts = () => (visible ? hide() : show());

export function useShowAmounts() {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => visible);
}

export const MASK = "Rp ••••••••";
export const money = (n, shown) => (shown ? formatIDR(n) : MASK);
